import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useLocation, useHistory } from 'react-router-dom';
import {observer} from "mobx-react-lite"
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import ApprovalList from './ApprovalList';
import DateUtil from "utils/DateUtil";
import CommonUtil from 'utils/CommonUtil';
import UIUtils from "utils/UIUtils";
import UIInputPW from "components/input/inputPW";
import paramStore from "common/page/store/ParamStore";
import message from "common/message/source/MessageSource";
function ContentsContainer() {
	const location = useLocation();
	const searchData = (location.state as any)?.data;
  	const receivedData = paramStore.getParam("adm7101");
  	const TNK_SR = window["TNK_SR"];
	const history = useHistory();
	const [PAY_REQ_NO, setPAY_REQ_NO] = useState<string>();
	const [LAST_STATUS, setLAST_STATUS] = useState('');
	const [TSK_REQ_NO, setTSK_REQ_NO] = useState('');
	const [REG_DATE, setREG_DATE] = useState('');
	const [REG_NUM, setREG_NUM] = useState('');
	const [TOTALCNT, setTOTALCNT] = useState('');	
	const [response, setResponse] = useState('');
	const [REG_PERSON_NM, setREG_PERSON_NM] = useState('');
	const [REG_DATETIME, setREG_DATETIME] = useState('');
	const [MEMO, setMEMO] = useState('');
	const [RTN_MSG, setRTN_MSG] = useState('');
	const [APPR_MSG, setAPPR_MSG] = useState('');
	const [PAY_REQ_NO_DISP, setPAY_REQ_NO_DISP] = useState('');
	const [CORP_NM, setCORP_NM] = useState('');
	const [TSK_NM, setTSK_NM] = useState('');
	const [TSK_ST_EN_DATE, setTSK_ST_EN_DATE] = useState('');
	const [BIZ_NM, setBIZ_NM] = useState('');
	const [FUN_PUR_USE_NM, setFUN_PUR_USE_NM] = useState('');
	const [PERF_CNT, setPERF_CNT] = useState('');
	const [SM_CNT, setSM_CNT] = useState('');
	const [REGI_AMT, setREGI_AMT] = useState('');
	const [POST_SETTILEMENT_NM, setPOST_SETTILEMENT_NM] = useState('');
	const [SUM_REGI_AMT, setSUM_REGI_AMT] = useState('');
	const [SUM_NOR_AMT, setSUM_NOR_AMT] = useState('');
	const [SUM_NON_AMT, setSUM_NON_AMT] = useState('');
	const [RTN_MSG_IN, setRTN_MSG_IN] = useState('');
	const [RTN_MSG_IN2, setRTN_MSG_IN2] = useState('');
	const [PAY_REQ_STS_CD, setPAY_REQ_STS_CD] = useState('');
	const [SUB_YN, setSUB_YN] = useState('');
	const [TSK_REQ_MODI_SEQ, setTSK_REQ_MODI_SEQ] = useState('');
	const [BIZ_CD, setBIZ_CD] = useState('');
	const [onCapsLock, setOnCapsLock] = React.useState(false);
	const [ACCT_NO_DISP, setACCT_NO_DISP] = useState('');
	const [BAL_AMT, setBAL_AMT] = useState('');
	const [EXE_AMT, setEXE_AMT] = useState('');
	const [SUPP_CORP_CNT, setSUPP_CORP_CNT] = useState('');
	const [LOGIN_NM, setLOGIN_NM] = useState('');
	const [BAL_AMT_CHECK, setBAL_AMT_CHECK] = useState(false);
	const [FDS_CHECK, setFDS_CHECK] = useState(false);
    const [password, setPassword] = React.useState<string>("");
	const [errorCode, setErrorCode] = React.useState<string>("");
	const [CLO_YN, setCLO_YN] = useState('');
	const [WITHDRAW_YN, setWITHDRAW_YN] = useState('');    
	const [modal7104IsOpen, setmodal7104IsOpen] = useState(false);
	const [modal7103IsOpen, setmodal7103IsOpen] = useState(false);
	const [modal7102IsOpen, setmodal7102IsOpen] = useState(false);
	
	const TranForm = React.useRef<HTMLFormElement>(null);
		
    let totalCnt_dev;
    let SheetData = {};
	const formId = "TranForm";
	
	var ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
	            "SearchMode": 0,
	            "SectionCanResize": 1,
	            "CanSort": false,
	            "CanColMove": false,
	            "CanColResize": false,
	            "HeaderCheck": 0,
	            "CanEdit": 0,
	            "Hover": 0,
	            "Height": "auto",
	            "InfoRowConfig": {
	                "Visible": false
           		},
            
			},
				//틀고정 좌측 컬럼 설정
			"Cols": [
	            {"Header": "NO",			"Type": "Int",	"Name": "SEQ",				"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
	            {"Header": "집행유형",			"Type": "Text",	"Name": "SUPP_TP_NM",		"RelWidth": 1,		"Align": "left",	"CanEdit": 0},
	            {"Header": "집행대상",			"Type": "Text",	"Name": "CORP_NM",			"RelWidth": 2,		"Align": "left",	"CanEdit": 0},
	            {"Header": "사업자등록번호",		"Type": "Text",	"Name": "BIZ_NO_DISP",		"RelWidth": 1.5,	"Align": "Center",	"CanEdit": 0},
	            {"Header": "지급신청금액(원)",	"Type": "Int",	"Name": "TRAN_AMT",			"RelWidth": 2, 		"Align": "Right",	"CanEdit": 0, "Format": "#,###"},
	            {"Header": "대표자명",			"Type": "Text",	"Name": "CEO_NM",			"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
	            {"Header": "지급은행",			"Type": "Text",	"Name": "IN_BANK_NM",		"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
	            {"Header": "지급계좌",			"Type": "Text",	"Name": "ACCT_NO",			"RelWidth": 2, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "예금주",			"Type": "Text",	"Name": "REGI_REF_NM",		"RelWidth": 2,	"Align": "Center",	"CanEdit": 0},
				{"Header": "최초거래",			"Type": "Text",	"Name": "NEW_SUPP_CORP_YN",	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "수취인",			"Type": "Text",	"Name": "FIND_REF_NM",		"RelWidth": 1.5, 	"Align": "left",	"CanEdit": 0,},
				{"Header": "이체일자",			"Type": "Text",	"Name": "TRAN_DATE",			"RelWidth": 1.5, "CustomFormat": "####-##-##",		"Align": "Center",	"CanEdit": 0 },
				{"Header": "이체결과",			"Type": "Text",	"Name": "END_NM",			"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
				{"Header": "사업명",			"Type": "Text",	"Name": "BIZ_NM",			"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},         
	            {"Header": "PROC_STS",		"Type": "Text",	"Name": "PROC_STS",			"RelWidth": 1, 		Visible : 0},
	            {"Header": "ERR_MESSAGE",	"Type": "Text",	"Name": "ERR_MESSAGE",		"RelWidth": 1, 		Visible : 0},
            ],
       
		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				initSheet();
				
			},
			onAfterClick:function(evtParam){
				if(evtParam.col === 'END_NM' ){
					if ( evtParam.row.PROC_STS !== '0000' && evtParam.row.PROC_STS !== '' && evtParam.row.PROC_STS !== null ){
						UIUtils.alert(evtParam.row.ERR_MESSAGE + '(오류코드 : ' + evtParam.row.PROC_STS + ')').then();
						return;
					}
				}
		    },				

		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'MainSheet', // 생성할 시트의 id
				el: 'ap_trade_detail', //시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData
				
			});
			// global 변수 선언
			//@ts-ignore
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.MainSheet.down2Excel({fileName: "결재함 상세_"+today+".xlsx", SheetDesign:3, excelRowHeight:16.5, excelFontSize:10, downCols: "Visible"});
			
		},

	}

    async function initSheet() {

        setPAY_REQ_NO(receivedData.vPAY_REQ_NO);
        setREG_DATE(receivedData.vREG_DATE);
        setREG_NUM(receivedData.vREG_NUM);
        //setLAST_STATUS(receivedData.vLAST_STATUS);

		let param = {
			"REG_DATE": receivedData.vREG_DATE,
			"REG_NUM" : receivedData.vREG_NUM,
			"BIZ_NO" : receivedData.vBIZ_NO,
		};
		
		const response:any = await CommonUtil.execute({
            url:"adm_7101_r001",
            data: param
        })
    	.then((response: any) => {
			setResponse(response);
	        setREG_PERSON_NM(response.REG_PERSON_NM);
	        setREG_DATETIME(response.REG_DATETIME);
	        setMEMO(response.MEMO);
	        setRTN_MSG(response.RTN_MSG);
	        setPAY_REQ_NO_DISP(response.PAY_REQ_NO_DISP);
	        setCORP_NM(response.CORP_NM);
			setTSK_NM(response.TSK_NM);
			setTSK_ST_EN_DATE(response.TSK_ST_EN_DATE);
			setBIZ_NM(response.BIZ_NM);
			setFUN_PUR_USE_NM(response.FUN_PUR_USE_NM);
			setPERF_CNT(response.PERF_CNT);
			setSM_CNT(response.SM_CNT);
			setREGI_AMT(response.REGI_AMT);
			setPOST_SETTILEMENT_NM(response.POST_SETTILEMENT_NM);
			setSUM_REGI_AMT(response.SUM_REGI_AMT);
			setSUM_NOR_AMT(response.SUM_NOR_AMT);
			setSUM_NON_AMT(response.SUM_NON_AMT);
			setTSK_REQ_NO(response.TSK_REQ_NO);
			setLAST_STATUS(response.LAST_STATUS);
			setACCT_NO_DISP(response.ACCT_NO_DISP);
			setSUPP_CORP_CNT(response.SUPP_CORP_CNT);

			if ( response.BAL_AMT === null){setBAL_AMT('0');}
			else {setBAL_AMT(response.BAL_AMT);}
			
			setLOGIN_NM(response.LOGIN_NM);

			if ( response.EXE_AMT === null){setEXE_AMT('0');}
			else {setEXE_AMT(response.EXE_AMT);}


			setPAY_REQ_STS_CD(response.PAY_REQ_STS_CD);
			setSUB_YN(response.SUB_YN);
			setTSK_REQ_MODI_SEQ(response.TSK_REQ_MODI_SEQ);
			setBIZ_CD(response.BIZ_CD);
			setCLO_YN(response.CLO_YN);
			setWITHDRAW_YN(response.WITHDRAW_YN);
			
			if(response.LAST_STATUS < 20){
				//@ts-ignore
				MainSheet.hideCol("END_NM");				
			} else {
				//@ts-ignore
				MainSheet.showCol( "END_NM" );
			}

			if (response.LAST_STATUS != 52) {
				//@ts-ignore
				MainSheet.hideCol("BIZ_NM");
				//@ts-ignore
				MainSheet.hideCol("TRAN_DATE");
			}
			
			if(response.PERF_CNT !== ""){
				//@ts-ignore
				MainSheet.hideCol( "NEW_SUPP_CORP_YN" );
			} else {
				//@ts-ignore				
				MainSheet.showCol("NEW_SUPP_CORP_YN");
			}			
			
			totalCnt_dev = String(Object.keys(response.REC2).length);
			setTOTALCNT(totalCnt_dev);
	
			let data = response.REC2;

			SheetData = data;
			//@ts-ignore
	        MainSheet.loadSearchData(data);
	        //@ts-ignore		
	        MainSheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        
	        return response;
       	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return {};
    	});	         
		return response;
	}
		
    async function onClickList() {
		/*
		var sStartDate = receivedData.sStartDate;
		var sEndDate = receivedData.sEndDate;
		var sLAST_STATUS = receivedData.sLAST_STATUS;
		var sBIZ_CD = receivedData.sBIZ_CD;
		var sCORP_NM = receivedData.sCORP_NM;
		var sTSK_NM = receivedData.sTSK_NM;	    
	    let dataToSend = {sStartDate,sEndDate,sLAST_STATUS,sBIZ_CD,sCORP_NM,sTSK_NM};
	    */
		//paramStore.setParam("adm7100", receivedData);
		
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: './adm7100',
	      state: { data: searchData }
	    });

    };
    
	async function onClickCompanion(event) {
		event.preventDefault();	
		
		if( RTN_MSG_IN === '' ){
			UIUtils.alert('반려사유를 작성해주세요.').then();
			return;
		} 
		if( RTN_MSG_IN2 === '' ){
			UIUtils.alert('심사의견을 작성해주세요.').then();
			return;
		} 

		if(await UIUtils.confirm('반려하시겠습니까?')){				
	 		let param = {
				"REG_DATE" : REG_DATE,
				"REG_NUM" : REG_NUM,
				"APPR_STAP_NO" : receivedData.vAPPR_STAP_NO,
				"SAN_STS": '2',
				"LAST_STATUS" : "32",
				"END_GB" : "9",
				"SANCTION_GB" : "2",
				"RTN_STEP_NO" : receivedData.vAPPR_STAP_NO,
				"RTN_MSG" : RTN_MSG_IN,
				"RTN_MSG2" : RTN_MSG_IN2,
				"PAY_REQ_NO" : PAY_REQ_NO,
				"BIZ_NO" : receivedData.vBIZ_NO,
				"BIZ_CD" : BIZ_CD
			};

			const response:any = await CommonUtil.execute({
	            url:"adm_7101_u002",
	            data: param
	        })
        	.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then(()=>{
					onClose7103();
					initSheet();
				});
        	}).catch((error) => {
            	CommonUtil.showAxiosError(error);
            	return;
        	});	        
		}
    };      
    	
	async function onClickApproval(event) {
		event.preventDefault();	

		if(await UIUtils.confirm('결재하시겠습니까?')){	
			let vLAST_STATUS;
			let vCURRENT_LINE_NO;
			if ( receivedData.vLAST_SAN_YN === 'Y'){
				vLAST_STATUS = '15';
				vCURRENT_LINE_NO = '0';
			} else {
				vLAST_STATUS = '10';
				vCURRENT_LINE_NO = '1';
			}			

			const response:any = await CommonUtil.execute({
	            url:"adm_7101_u003",
	            data: {
					"REG_DATE" : REG_DATE,
					"REG_NUM" : REG_NUM,
					"APPR_STAP_NO" : receivedData.vAPPR_STAP_NO,
					"SAN_STS": '1',
					"CURRENT_LINE_NO": vCURRENT_LINE_NO,
					"LAST_STATUS" : vLAST_STATUS,
					"APPR_MSG" : APPR_MSG,
					"PAY_REQ_NO" : PAY_REQ_NO,
				}
	        })
        	.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then(()=>{
					onClose7104();
					initSheet();
				});	
        	}).catch((error) => {
            	CommonUtil.showAxiosError(error);
            	return;
        	});
				
		}
	}; 	

	
	async function onAfterOpen() {
		getTNKSR().then((result) => {
			window["TNK_SR"] = result;
			window["tekOption"].srdk = result;

			if (window["loadflag"] === true) {
				// @ts-ignore
				window.TK_Rescan()
			} else {
				// @ts-ignore
				window.TK_Loading()
			}
		}).catch((err) => {
			alert(err);
		});
		
		setErrorCode('');
		
		const response:any = await CommonUtil.execute({
            url:"adm_7101_s004",
            data: {
			}
        })
		.then((response: any) => {    
			if(typeof response.FDS_START_TIME == 'undefined' || typeof response.FDS_END_TIME == 'undefined'){
				setFDS_CHECK(true);
				return;
			}
			
			let Current:string = DateUtil.currentDateFormat("HHmmss");

			if (response.FDS_START_TIME > Current && response.FDS_END_TIME < Current){
				setFDS_CHECK(true);	
			} else {
				setFDS_CHECK(false);
			}
			
			var bal_amt = 0
			var exe_amt = 0
			bal_amt = Number(BAL_AMT.replace(/,/g, ""));
			exe_amt = Number(EXE_AMT.replace(/,/g, ""));
			
			if (bal_amt >= exe_amt){
				setBAL_AMT_CHECK(true);
			} else {
				setBAL_AMT_CHECK(false);
			}
			
			//setBAL_AMT_CHECK(response.BAL_AMT_CHECK);
			
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});
    			
	}

	async function onClickExecute(event) {
        event.preventDefault();		
		if( !BAL_AMT_CHECK ){
			UIUtils.alert('잔액이 부족합니다.').then();
			return;
		}		
		
		if( !FDS_CHECK ){
			if(await UIUtils.confirm('이상거래감지 집행통제 시간대입니다. 이체하겠습니까?')){

			} else {
				return;	
			}
		}		

		if(await UIUtils.confirm('이체하시겠습니까?')){				
			const response:any = await CommonUtil.execute({
	            url:"adm_7101_u005",
	            data : {
					"REG_DATE" : REG_DATE,
					"REG_NUM" : REG_NUM,
				},
	            form : TranForm.current as HTMLFormElement,
	        })
	        
        	.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then(()=>{
					onClose7102();
					initSheet();
				});	
        	}).catch((error) => {
                setErrorCode(error.COMMON_HEAD.CODE || "");
                if(error.COMMON_HEAD.CODE !== 'LOGIN9003'
                    && error.COMMON_HEAD.CODE !== 'LOGIN9004'
                    && error.COMMON_HEAD.CODE !== 'LOGIN9005'
                    && error.COMMON_HEAD.CODE !== 'LOGIN9006'
                ) {
                    UIUtils.error(error.COMMON_HEAD.MESSAGE||"", error.COMMON_HEAD.CODE||"").then(()=> {

                    });
                }                
            	return;
        	});
		}
        
	};    		


	async function onClickReExecute(event) {
		var count = 0;
		// @ts-ignore
		var rows = MainSheet.getDataRows();
		
		for (var i = 0; i < rows.length; i++) {
			if ( rows[i]["PROC_STS"] !==  '0000'){
				count++;
			}
		}
		
		if( count === 0 ){
			UIUtils.alert('오류건이 존재하지 않습니다.').then();
			return;
		}		
		
		event.preventDefault();	
		if(await UIUtils.confirm('오류건 재실행하시겠습니까?')){				
			const response:any = await CommonUtil.execute({
	            url:"adm_7101_u006",
	            data: {
					"REG_DATE" : REG_DATE,
					"REG_NUM" : REG_NUM,
					"PAY_REQ_NO" : PAY_REQ_NO,
				}
	        })
        	.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then(()=>{
					initSheet();
				});
        	}).catch((error) => {	        
	     		return   	
			});	
		}
        
	};  	

	async function onClickWithdraw(event) {
		event.preventDefault();
		
		    // 최신 데이터 가져오기
	    const latestData = await initSheet();  // 최신 데이터를 가져오도록 수정
	
	    console.log("최신 WITHDRAW_YN 값:", latestData.WITHDRAW_YN); // 최신 값 확인
	
	    if (latestData.WITHDRAW_YN !== 'Y') {  
				UIUtils.alert('회수가 불가능한상태입니다.').then();
			return;
		}
				
		if(await UIUtils.confirm('회수하시겠습니까?')){				
			const response:any = await CommonUtil.execute({
	            url:"adm_7101_u007",
	            data: {
					"REG_DATE" : REG_DATE,
					"REG_NUM" : REG_NUM,
					"PAY_REQ_NO" : PAY_REQ_NO,
				}
	        })
        	.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then(()=>{
					onClickList();
				});
        	}).catch((error) => {	        
		   		return   	
			});	
		}
        
	};  	
	
	async function onClose7104() {
		setmodal7104IsOpen(false);
		setAPPR_MSG('');
	}	

	async function onClose7103() {
		setmodal7103IsOpen(false);
		setRTN_MSG_IN('');
		setRTN_MSG_IN2('');
	}	


	async function onClose7102() {
		setmodal7102IsOpen(false);
		
	}	

 	const handleChange_modal7104 = (event) => {
		event.preventDefault();
		setAPPR_MSG(event.target.value);
	};

 	const handleChange_modal7103 = (event) => {
		event.preventDefault();
		setRTN_MSG_IN(event.target.value);
	};

 	const handleChange_modal7103_2 = (event) => {
		event.preventDefault();
		setRTN_MSG_IN2(event.target.value);
	};
    		
    async function onClickDetail_Pay() {
		var vPAY_REQ_NO = PAY_REQ_NO;
		var vPAY_REQ_STS_CD = PAY_REQ_STS_CD;
		var vSUB_YN = SUB_YN;
		var vPageNum = '7101';
				
	    let dataToSend = {vPAY_REQ_NO, vPAY_REQ_STS_CD, vSUB_YN, vPageNum};
	    paramStore.setParam("adm1406", dataToSend);
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
			pathname: '../adm_1000/adm1406',
			state: { data: dataToSend }
	    });
		
    };  
    
        
    async function onClickDetail_Task() {
		var vTSK_REQ_NO = TSK_REQ_NO;
		var vTSK_REQ_MODI_SEQ = TSK_REQ_MODI_SEQ;
		//console.log(vTSK_REQ_NO);
		//console.log(vTSK_REQ_MODI_SEQ);
			
		let dataToSend = {vTSK_REQ_NO, vTSK_REQ_MODI_SEQ};
		paramStore.setParam("adm1306", dataToSend);
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: '../adm_1000/adm1306',
			state: { data: dataToSend }
		});
	
	}
	
	useEffect(() => {
		if( receivedData === undefined ){
			onClickList();
		}
        // @ts-egnore
		ib.create();

        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);
        }		

    },[])	
    		
	// 키보드 보안모듈의 srdk 조회
    const getTNKSR = async () => {
        const response = await axios.post('/nx/NxKeyTNKSR.do', {});
        if (response.status === 200) {
            const responseText = response.data;
            const result = responseText.replaceAll(/(\r\n|\n|\r)/gm, "");

            if (typeof TNK_SR == 'undefined') {
                throw new Error('TNK_SR value is not loaded!!!')
            }
            return result;
        }
    }

	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li><Link to="/admin/">홈</Link></li>
						<li><Link to="#">관리자페이지</Link></li>
						<li><Link to="#">결재함</Link></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">결재함 상세</h1>
						<h3 className="section-title mb15">결재선</h3>
						<ApprovalList response={response} />
						<h3 className="section-title mb15">결재상신</h3>
						<form className="fo fo-col2 mb30" >
							<div className="inner">
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">결재상태</p>
									<div id='last_status' className="fo-value">
										{LAST_STATUS === '11' && <label className="badge badge-23 red">결재대기</label>}
										{LAST_STATUS === '10' && <label className="badge badge-23 blue">결재중</label>}
										{LAST_STATUS === '15' && <label className="badge badge-23 green">전결</label>}
										{LAST_STATUS === '32' && <label className="badge badge-23 red">반려</label>}
										{LAST_STATUS === '20' && <label className="badge badge-23 gray">집행요청</label>}
										{LAST_STATUS === '51' && <label className="badge badge-23 gray">집행처리중</label>}
										{LAST_STATUS === '52' && <label className="badge badge-23 gray">집행완료</label>}
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">등록자</p>
									<div className="fo-value">
										<input className='tf tf-md w100p' value={REG_PERSON_NM} placeholder="" readOnly/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">등록일</p>
									<div className="fo-value">
										<input className='tf tf-md w100p' value={REG_DATETIME} placeholder="" readOnly/>
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">내용</p>
									<div className="fo-value">
										<div className="ta-view ta-view-white w100p">
											{MEMO}
										</div>
									</div>
								</div>
								
								{/* [D] 반려 */}
								{RTN_MSG !== '' &&
								<div className="fo-item fo-m-1-3" hidden>
									<p className="fo-key">반려사유</p>
									<div className="fo-value">
										<div className="ta-view ta-view-white w100p">
											{RTN_MSG}
										</div>
									</div>
								</div>
								}
								{/* //[D] 반려 */}

							</div>
						</form>

						<h3 className="section-title mb15">지급신청 정보</h3>
						<form className="fo fo-col2 mb30" name="" action="" method="" >
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">지급신청번호</p> 
									<div className="fo-value">
										<Link className="tx tx-cp1 tx-link2" to="#" onClick={onClickDetail_Pay}>{PAY_REQ_NO_DISP}</Link>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">출연기업</p>
									<div className="fo-value">
										<input className='tf tf-md w100p' value={CORP_NM} placeholder="" readOnly/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">과제명</p>
									<div className="fo-value">
										<Link className="tx tx-cp1 tx-link2" to="#" onClick={onClickDetail_Task}>{TSK_NM}</Link>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">과제기간</p>
									<div className="fo-value">
										<input className='tf tf-md w100p' value={TSK_ST_EN_DATE} placeholder="" readOnly/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업명</p>
									<div className="fo-value">
										<input className='tf tf-md w100p' value={BIZ_NM} placeholder="" readOnly/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">기금사용용도</p>
									<div className="fo-value">
										<input className='tf tf-md w100p' value={FUN_PUR_USE_NM} placeholder="" readOnly/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">수행기업</p>
									<div className="fo-value">
										<div className="hz-root hz-right w100p">
											<div className="hz-item tf-unit">
												<input readOnly name="" id="" className="tf tf-md ta-right" type="text" value={PERF_CNT} placeholder="" />
											</div>
										</div>

									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">중소기업</p>
									<div className="fo-value">
										<div className="hz-root hz-right w100p">
											<div className="hz-item tf-unit">
												<input readOnly name="" id="" className="tf tf-md ta-right" type="text" value={SM_CNT} placeholder="" />
											</div>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">지급신청금액(합계)</p>
									<div className="fo-value">
										<div className="hz-root hz-right w100p">
											<div className="hz-item tf-unit">
												<input readOnly name="" id="" className="tf tf-md ta-right" type="text" value={REGI_AMT} placeholder="" />
											</div>										
										</div>							
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">지원금 지급방식</p>
									<div className="fo-value">
										<input readOnly name="" id="" className="tf tf-md w100p" type="text" value={POST_SETTILEMENT_NM} placeholder="" />
									</div>
								</div>
							</div>
						</form>
						<h3 className="section-title mb15">기업목록</h3>
						<div className="tb-top">
							<div className="hz-root hz-gap15">
								<div className="hz-item">
									<p className="tx fc-black"></p>총 <em className="fw500">{TOTALCNT}</em>건
								</div>
								{LAST_STATUS !== '52' && 
								<div className="hz-item">
									<em className="fc-black">지급신청금액 합계</em> <span className="price">{SUM_REGI_AMT}</span>원  &nbsp;&nbsp;&nbsp;
								</div>
								}
								{LAST_STATUS === '52' && 
								<div className="hz-item">
									<em className="fc-black">지급신청금액 합계</em> <span className="price">{SUM_REGI_AMT}</span>원  &nbsp;&nbsp;&nbsp;
									<em className="fc-black">집행금액(합계)</em> <span className="price">{SUM_NOR_AMT}</span>원  &nbsp;&nbsp;&nbsp;
									<em className="fc-black">미집행금액(합계)</em> <span className="price fc-err">{SUM_NON_AMT}</span>원 
								</div>
								}
							</div>
							<div className="hz-root hz-gap5">
								<button className="bt bt-sm bt-gray-o" type="button" onClick={()=> ib.exportData()}>다운로드</button>							
							</div>
						</div>
						<div className="ibsheet" id='ap_trade_detail'></div>
						<div className="hz-root hz-right hz-gap5 mt10">
							{WITHDRAW_YN === 'Y' && <Button color="gray-o" size="sm" onClick={onClickWithdraw}>회수</Button>}
							{LAST_STATUS === '11' && <Button color="gray-o" size="sm" onClick={() => setmodal7103IsOpen(true)}>반려</Button>}
							{LAST_STATUS === '11' && <Button color="pri-o" size="sm"onClick={() => setmodal7104IsOpen(true)}>결재</Button>}
							{CLO_YN === 'N' && LAST_STATUS === '15' && receivedData.vEXECUTE_YN === 'Y' && <Button color="pri-o" size="sm" onClick={() => setmodal7102IsOpen(true)}>이체</Button>}
							{CLO_YN === 'N' && LAST_STATUS === '52' && receivedData.vEXECUTE_YN === 'Y' && SUM_NON_AMT !== '0' && <Button color="pri-o" size="sm" onClick={onClickReExecute}>오류건 재실행</Button>}
							<Button color="gray-o" size="sm" onClick={() => window.history.back()}>목록</Button>
						</div>
					</main>
				</div>
				
			{/* modal - 7104 */}	
			<ModalPopup
				open={modal7104IsOpen}
				title="결재"
				size="mid"
				onClose={() => onClose7104()}
			>
				<div className="modal-con">

					<form className="fo fo-col2" name="" action="" method="" >
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">지급신청번호</p>
								<div className="fo-value">
									<input readOnly name="" id="" className="tf tf-md w100p" type="text" value={PAY_REQ_NO_DISP} placeholder="" />
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">결재의견</p>
								<div className="fo-value">
									<div className="ta w100p h100">
										<textarea className="ta-ip" placeholder="" value={APPR_MSG} onChange={handleChange_modal7104}></textarea>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={() => setmodal7104IsOpen(false)}>취소</Button>
						<Button color='pri' size="md" onClick={onClickApproval}>결재</Button>
					</div>
				</div>	
			</ModalPopup>
			
			{/* modal - 7103 */}	
			<ModalPopup
				open={modal7103IsOpen}
				title="반려사유"
				size="mid"
				onClose={() => onClose7103()}
			>
				<div className="modal-con">

					<form className="fo fo-col2" name="" action="" method="" >
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">지급신청번호</p>
								<div className="fo-value">
									<input readOnly name="" id="" className="tf tf-md w100p" type="text" value={PAY_REQ_NO_DISP} placeholder="" />
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">
								반려사유<br/>
								(재단내부직원확인용)</p>
								<div className="fo-value">
									<div className="ta w100p h100">
										<textarea className="ta-ip" placeholder="" value={RTN_MSG_IN} onChange={handleChange_modal7103}></textarea>
									</div>
								</div>
							</div>

							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">
								심사의견<br/>
								(출연기업 전달용)
								</p>
								<div className="fo-value">
									<div className="ta w100p h100">
										<textarea className="ta-ip" placeholder="" value={RTN_MSG_IN2} onChange={handleChange_modal7103_2}></textarea>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={() => setmodal7103IsOpen(false)}>취소</Button>
						<Button color='pri' size="md" onClick={onClickCompanion}>반려</Button>
					</div>
				</div>	
			</ModalPopup>

			{/* modal - 7102 */}	
			<ModalPopup
				open={modal7102IsOpen}
				title="이체실행"
				size="lg"
				onClose={() => onClose7102()}
				onAfterOpen={() => onAfterOpen()}
			>
				<div className="modal-con">
					<form className="fo fo-col2" id={formId} name={formId} ref={TranForm} >
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">출금계좌</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={ACCT_NO_DISP} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">잔액</p>
								<div className="fo-value">
									<div className="hz-root hz-right w100p">
										<div className="hz-item tf-unit">
											<input readOnly name="" id="" className="tf tf-md ta-right" type="text" value={BAL_AMT} placeholder="" />
											<span className="u">원</span>
										</div>
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">지원기업수</p>
								<div className="fo-value">
									<div className="hz-root hz-right w100p">
										<div className="hz-item tf-unit">
											<input readOnly name="" id="" className="tf tf-md ta-right" type="text" value={SUPP_CORP_CNT} placeholder="" />
											<span className="u">개</span>
										</div>
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">집행금액(합계)</p>
								<div className="fo-value">
									<div className="hz-root hz-right w100p">
										<div className="hz-item tf-unit">
											<input readOnly name="" id="" className="tf tf-md ta-right" type="text" value={EXE_AMT} placeholder="" />
											<span className="u">원</span>
										</div>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">비밀번호</p>
								<div className="fo-value">
									{/*<UIInputPW className={'tf tf-md w245'} value={''} placeholder={''} readOnly={false} type="password" />*/}
	                                <UIInput
	                                    className={'tf tf-md w245'}
	                                    value={LOGIN_NM}
	                                    attrs={{
	                                        name: "USERNAME",
	                                        alt: "아이디를 입력하세요",
	                                        tabIndex: 1
	                                    }}
	                                    readOnly={false}
	                                    // onKeyEnter={() => setFocusName("password")}
	                                    valueChanged={(value) => setLOGIN_NM(value)}
	                                    rules={["required"]}
	                                    type="hidden"
	                                />
	                                <UIInputPW
	                                    className={'tf tf-md w245'}
	                                    placeholder={'비밀번호를 입력하세요'}
	                                    attrs={{
	                                        name: "PASSWORD",
	                                        alt: "비밀번호를 입력하세요",
	                                        tabIndex: 2,
	                                        autoComplete: "on",
	                                    }}		                                    
	                                    readOnly={false}
	                                    //onKeyEnter={onClickExecute}
	                                    valueChanged={(value) => setPassword(value)}
	                                    rules={["required","password"]}
	                                    focusClear={true}
	                                    isOnCapsLock={result => setOnCapsLock(result)}
	                                />
	                                <UIInput type="hidden"
	                                         attrs={{name: "LOGIN_AUTH"}}
	                                         value={"admin"}
	                                />
									<div className="fo-value">
			                            {password.length < 8 && <p className="tx tx-alert ml10">{message.get("common.user.message.inputLoginPassword")}</p>}
			                            {onCapsLock && <p className="tx tx-alert">Caps Lock이 켜져있습니다.</p>}
			                            {errorCode === 'LOGIN9003' && <p className="tx tx-alert ml10">비밀번호가 일치하지 않습니다.</p>}
			                            {errorCode === 'LOGIN9004' && <p className="tx tx-alert ml10">비밀번호 5회이상 일치하지 않아 잠겼습니다.</p>}
			                            {errorCode === 'LOGIN9005' && <p className="tx tx-alert ml10">사용자가 비활성화되었습니다.</p>}
			                            {errorCode ==='LOGIN9006' && <p className="tx tx-alert ml10">사용자가 만료되었습니다.</p>}
									</div>		                                
								</div>
							</div>
						</div>
					</form>											
					<div className="modal-bottom">
						<div className="hz-root hz-gap8">
							<Button color='gray-o' size="md" onClick={() => setmodal7102IsOpen(false)}>취소</Button>
							<Button color='pri' size="md" type="submit" onClick={onClickExecute}>이체실행</Button>
						</div>
					</div>
				</div>
			</ModalPopup>			
		</PageContainer>
	);
}
export default observer(ContentsContainer);